module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"body":"You have been invited to join one or more organization. Please check your profile page for more details.","title":"You have pending invitations"},"fr":{"body":"Vous avez été invité(e) à rejoindre une ou plusieurs organisations. Veuillez consulter votre profile pour plus de détails.","title":"Vous avez des invitations en attente"}}')
  delete Component.options._Ctor
}
